const e={content:{}},t={modalTheme:e};export{t as defaultTheme};
//# sourceMappingURL=defaults.js.map
